import React, { useContext, useEffect, useState } from "react"
import { HeaderWrapper, Balance, RightWrapper } from "./HeaderStyles"
import Burger from "./elements/Burger"
import { Currencies } from "@orbital/games-frontend-library"
import floorFigure from "../configs/floorFigure"
import { AppContext, GameBoardContext } from "../../context/createContext"
import ToggleMenu from "./elements/toggleMenu/ToggleMenu"
import ToggleMenuMobile from "./elements/toggleMenu/ToggleMenuMobile"
import Title from "./elements/Title"
import useReize from "../../helpers/useResize"
import { isTablet } from "react-device-detect"
// import FPSLogger from "../fpslogger";

interface Header_Props {
  isLoading: boolean
  tempRemoveComponents: boolean
}

export default function Header({
  isLoading,
  tempRemoveComponents,
}: Header_Props) {
  const { auth, balanceUpdate, jackpot, config } = useContext(AppContext)
  const { settings } = useContext(GameBoardContext)
  const {
    balance: { amount, currency },
  } = auth
  const { prec } = config
  const { isMobile } = useReize()
  const [updateBalance, setUpdateBalance] = useState(amount)
  const [showHeader, setShowHeader] = useState<boolean>(false)

  useEffect(() => {
    !isLoading && setShowHeader(true)
  }, [isLoading])

  useEffect(() => {
    const balanceNew =
      balanceUpdate.balance !== undefined && balanceUpdate.balance !== ""
        ? balanceUpdate.balance
        : amount
    setUpdateBalance(balanceNew)
  }, [balanceUpdate, amount])

  useEffect(() => {
    jackpot.wintype !== 0 &&
      jackpot.balance !== "" &&
      setUpdateBalance(jackpot.balance)
  }, [jackpot])

  const url =
    window.location != window.parent.location
      ? document.referrer
      : document.location.href

  const Bg =
    settings.settingsSubpage !== "" && (window.innerWidth < 768 || isMobile)

  // const { fps } = FPSLogger();
  return (
    <HeaderWrapper
      showSettings={(settings.showSettings && !isMobile) || Bg}
      isLoading={showHeader}
      tempRemoveComponents={tempRemoveComponents}
    >
      <Title settings={settings} />
      <RightWrapper>
        {/* <div className="fps">{fps}</div> */}
        <Balance>
          <span style={{ marginRight: "2px" }}>{Currencies[currency]}</span>
          <p>
            {" "}
            {(+updateBalance).toLocaleString(undefined, {
              minimumFractionDigits: prec,
              maximumFractionDigits: prec,
            })}
          </p>
        </Balance>

        <Burger />
      </RightWrapper>
      {isMobile && <ToggleMenuMobile />}
      {!isMobile && <ToggleMenu />}
    </HeaderWrapper>
  )
}
